var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"z-index":"1100","height":"70px"},attrs:{"id":"logo","dark":"","align":"center"}},[_c('span',[_vm._v(" Powered by ")]),_c('v-img',{staticClass:"ml-1",attrs:{"src":_vm.getSrc('White-Text-SVG.svg'),"width":"100px","height":"auto","max-height":"70px","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }